var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentRelatedAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 17 16",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 12.5c0 .3.2.5.5.5s.5-.2.5-.5v-1.5h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.5v-1.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.5h-1.5c-.3 0-.5.2-.5.5s.2.5.5.5h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 13v1c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h5.5l4.5 4.5v3.5h-1v-3.5h-2c-.8 0-1.5-.7-1.5-1.5v-2h-5.5c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRelatedAddIcon);
export default __webpack_public_path__ + "static/media/document-related-add-icon.72ca676855d1ca76724c7a3cde08fa39.svg";
export { ForwardRef as ReactComponent };